import { Box, Paper } from "@mui/material";
import {
	ColDef,
	ColGroupDef,
	GridApi,
	GridReadyEvent,
} from "ag-grid-community"; // Import types
import { AgGridReact } from "ag-grid-react";
import { useRef, useState } from "react";
import { useCastersContext } from "../../../CastersContext";
import { useReadPLC } from "../../../hooks/useReadPLC";
import { useStrandTableData } from "./hooks/useStrandTableData";

import { useTableStyles } from "../../../styles/useTableStyles";
import { EditStrandModal } from "./modals/EditStrandModal";

interface Props {
	refreshData: Function;
}
export const StrandTable = ({ refreshData }: Props) => {
	const classes = useTableStyles();
	const { state, actions } = useCastersContext();
	const strands = state.strands || [];
	const gridApiRef = useRef<GridApi | null>(null);

	const [showEditModal, setShowEditModal] = useState(false);
	const [selectedStrandNum, setSelectedStrandNum] = useState<number | null>(
		null,
	);
	const [isLoading, setIsLoading] = useState(false);

	const { readStrand } = useReadPLC();

	const handleOnReadPLC = async (strand: number) => {
		setIsLoading(true);
		if (state.processData?.ProcessId != null) {
			await readStrand(state.processData.ProcessId, strand);
			refreshData();
		} else {
			actions.setErrorMessage("Cannot read PLC data: Process ID is missing.");
		}
		setIsLoading(false);
	};

	const handleEdit = (strandNum: number) => {
		setSelectedStrandNum(strandNum);
		setShowEditModal(true);
		actions.setRefreshInPause(true);
	};

	const handleCloseEditModal = () => {
		setShowEditModal(false);
		setSelectedStrandNum(null);
		actions.setRefreshInPause(false);
		actions.setErrorMessage(null);
	};

	const { columns, rowData } = useStrandTableData(
		strands,
		handleEdit,
		handleOnReadPLC,
		isLoading,
	);

	const onGridReady = (params: GridReadyEvent) => {
		gridApiRef.current = params.api;
	};

	return (
		<>
			<Paper elevation={0} className={classes.borderAgGridTable}>
				<Box p={0}>
					<div
						className={`${classes.materialTable}`}
						style={{ height: "30.67rem" }}
					>
						<AgGridReact
							suppressRowClickSelection={true}
							pagination={false}
							stopEditingWhenCellsLoseFocus={true}
							tooltipShowDelay={0}
							tooltipHideDelay={2000}
							suppressPropertyNamesCheck={true}
							rowData={rowData}
							columnDefs={columns as (ColDef | ColGroupDef)[]}
							domLayout="normal"
							onGridReady={onGridReady}
							suppressContextMenu
							getRowId={(params) => params.data.id}
						/>
					</div>
				</Box>
			</Paper>
			<EditStrandModal
				show={showEditModal}
				onHide={(shouldUpdate) => {
					if (shouldUpdate) {
						refreshData();
					}
					handleCloseEditModal();
				}}
				strandNum={selectedStrandNum}
			/>
		</>
	);
};
